

class Thing {

	constructor (public color: string, size: string, digital: boolean) {}

	show(): void {
		console.log("showing...");
	}

	take(): void {
		console.log("taking..");
	}
}

class Box extends Thing {
	show(): void {
		console.log(`here is the ${this.color} box!`);
	}

}

const box = new Box("black", "L", true);



box.show()
box.take()
console.log("newest");


